export const TABLE_DATA = [
    {
        id: 1,
        name: 'Mike Johnson',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 2,
        name: 'John Mikeson',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 3,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 4,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 5,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 6,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 7,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 8,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 9,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 10,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 11,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 12,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 13,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 14,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 15,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 16,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 17,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 18,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 19,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 20,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 21,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 22,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 23,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 24,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 25,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 26,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 27,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 28,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 29,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 30,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 31,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 32,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 33,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 34,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
    {
        id: 35,
        name: 'Mike',
        age: 32,
        address: '10 Downing Street',
    },
    {
        id: 36,
        name: 'John',
        age: 42,
        address: '10 Downing Street',
    },
];
